<template lang="pug">
  .b-tariffs-sidebar(v-if="tariff")
    ._left
      ._title Ваш баланс
      ._balance {{ balance }} ₽
    ._right
      ._selected-tariff Ваш тариф
        span {{ actualTariff.name }}
      ._days-left(v-if="actualTariff.pricePerDay > 0") Осталось {{ daysLeftStr }}
        span {{ pricePerDay || actualTariff.pricePerDay }} ₽/день
      ._days-left(v-else) Бессрочно
    ._more-expander(:class="{ expanded: moreExpanded }" @click="moreExpanded = !moreExpanded") Больше информации о тарифе
      Icon(name="angle-down" pointer)
    ._more-content(:class="{ expanded: moreExpanded }")
      ._left
        ._subtitle Вы использовали
        ._used-resources
          ._resource
            ._round-bar
              Icon(name="upload-green")
              ChartRoundBar._chart(:value="Math.min(user.projectCount, tariff.maxProjects)" :max="tariff.maxProjects")
            ._resource-name Проектов
            ._resource-val(:class="{ red: user.projectCount > tariff.maxProjects }") {{ user.projectCount }} из {{ tariff.maxProjects }}
          ._resource
            ._round-bar
              Icon(name="upload-green")
              ChartRoundBar._chart(:value="Math.min(storageCount, tariff.maxStorage)" :max="tariff.maxStorage")
            ._resource-name Хранилище, ГБ
            ._resource-val(:class="{ red: storageCount > maxStorage }") {{ storageCount }} из {{ maxStorage }}
      //._right
        ._subtitle Последний раз Вы оплачивали:
        ._grey-area
          img(src="/img/paysystem-sample.png" style="margin-right: 20px;")
          |Оплата картой
      //._subtitle Выбранный период оплаты:
      //._grey-area.-space-between
        ._selected-payment-period Годовой
        ._selected-price 4 800 ₽
          span /день

      ._both(v-if="user.projectCount >= actualTariff.maxProjects")
        ._error-message Достигнут лимит количества проектов. Рекомендуем подобрать другой тариф.
      ._both(v-if="user.storageCount >= actualTariff.maxStorage * 1024 * 1024 * 1024")
        ._error-message Закончилось место в хранилище. Рекомендуем подобрать другой тариф.
      ._left.-buttons(v-if="checkedTariff")
        Btn._btn-pay(lg :disabled="!tariffChangeAvailable || checkedTariff.pricePerDay <= 0" :to="{ name: 'pay', params: { tariffId: tariff.id } }") {{ checkedTariff === actualTariff ? 'Пополнить' : 'Сменить тариф и оплатить' }}
        Btn._btn-pay(lg :disabled="!tariffChangeAvailable || actualTariff === checkedTariff" @click="changeTariff") Изменить тариф
</template>

<script>
import api from '@/api/tariff';
import user from '@/model/user';
import utils from '@/utils/common';

import ChartRoundBar from '@/components/chart/ChartRoundBar.vue';

export default {
  name: 'TariffsSidebar',
  components: { ChartRoundBar },
  props: {
    actualTariff: Object,
    checkedTariff: Object,
  },
  data() {
    return {
      moreExpanded: false,
      pricePerDay: null,
    };
  },
  methods: {
    async changeTariff() {
      let daysStr = '';

      if (this.checkedTariff.pricePerDay > 0) {
        const days = Math.floor(this.user.accountBalance / (this.checkedTariff.pricePerDay * 0.5 * 100));
        daysStr = 'На новом тарифе при текущем балансе у Вас останется ' + utils.pluralWord(days, 'день', 'дня', 'дней'); // eslint-disable-line prefer-template
      }

      // const confirmation = `Вы действительно хотите изменить тариф на [${this.checkedTariff.name}]? Ваша скидочная цена будет аннулирована. ${daysStr}`;
      const confirmation = `Вы действительно хотите изменить тариф на [${this.checkedTariff.name}]?`;

      if (await this.$confirm(confirmation)) {
        api.select(this.checkedTariff.id, true)
          .then(() => { user.fetchSelf(); });
      }
    },
  },
  computed: {
    user() { return this.$store.state.auth.user; },
    maxStorage() { return this.tariff.maxStorage; }, // eslint-disable-line
    storageCount() { return Math.round(this.user.storageCount/1024/1024/1024 * 1000) / 1000 }, // eslint-disable-line
    balance() { return this.$store.state.auth.user.accountBalance / 100; },
    tariff() { return this.checkedTariff ?? this.actualTariff; },
    tariffChangeAvailable() { return this.storageCount <= this.maxStorage && this.user.projectCount <= this.tariff.maxProjects; },
    daysLeftStr() { return utils.pluralWord(this.daysLeft, 'день', 'дня', 'дней'); },
    daysLeft() {
      let balance = this.$store.state.auth.user.accountBalance;
      let daysLeft = 0;

      this.$store.state.auth.user.tariffInfo.forEach(discount => {
        if (!discount.days || typeof discount.price !== 'number') return; // discount is invalid
        if (this.pricePerDay === null) this.pricePerDay = discount.price / 100; // save first price

        const discountSum = discount.days * discount.price;
        if (discountSum <= balance) {
          balance -= discountSum;
          daysLeft += discount.days;
          return;
        }

        daysLeft = Math.floor(balance / discount.price);
        balance = 0;
      });

      daysLeft += Math.floor(balance / (this.actualTariff.pricePerDay * 100));

      return daysLeft;
    },
  },
};
</script>

<style scoped lang="scss">
.tariffs-sidebar {
  background: #FFFFFF;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 30px 20px;

  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #232226;
    margin-bottom: 12px;
  }

  &__balance {
    font-weight: 700;
    font-size: 30px;
    line-height: 38px;
    letter-spacing: 0.01em;
    color: #1E3147;
    margin-bottom: 15px;
  }

  &__selected-tariff {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;

    span {
      color: #33A1FB;
    }
  }

  &__days-left {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #788CA1;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;

    &--zero {
      color: #8E2D20;
      margin-bottom: 15px;
    }

    span {
      font-weight: 500;
      color: #33A1FB;
    }
  }

  &__subtitle {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: #1E3147;
    margin-bottom: 15px;
  }

  &__error-message {
    background: #FFE0CC;
    border-radius: 8px;
    padding: 15px 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #1E3147;
    margin-bottom: 20px;
  }

  &__used-resources {
    display: flex;
    justify-content: space-around;
    margin-bottom: 45px;
  }

  &__resource {
    display: flex;
    flex-direction: column;
    align-items: center;

    &-name {
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      letter-spacing: 0.02em;
      color: #1E3147;
      margin-bottom: 2px;
    }

    &-val {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      letter-spacing: 0.02em;
      color: #788CA1;

      &.red {
        color: red;
      }
    }
  }

  &__round-bar {
    position: relative;
    margin-bottom: 5px;

    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__grey-area {
    background: #F5F7F9;
    border-radius: 6px;
    display: flex;
    align-items: center;
    height: 75px;
    padding: 0 14px;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #232226;
    margin-bottom: 24px;

    &--space-between {
      justify-content: space-between;
    }
  }

  &__selected-payment-period {
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    letter-spacing: 0.01em;
    color: #788CA1;
  }

  &__selected-price {
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    letter-spacing: 0.01em;
    color: #33A1FB;

    span {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__btn-pay {
    width: 100%;
  }

  &__more {
    &-expander {
      display: none;
    }

    &-content {
      max-height: 1000px;
    }
  }

  &__left--buttons {
    display: grid;
    gap: 20px;
  }

  @media (max-width: 1500px) and (min-width: 576px) {
    display: grid;
    grid-template-columns: 1fr 1fr;

    &__left {
      grid-column: 1;
    }

    &__right {
      grid-column: 2;
    }

    &__both {
      grid-column: 1 / 2 span;
    }

    &__selected-tariff {
      display: block;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      color: #232226;
      margin-bottom: 0;

      span {
        margin-top: 12px;
        display: block;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.01em;
      }
    }

    &__more {
      &-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    }
  }

  @media (max-width: 1500px) {
    padding-bottom: 20px;

    &__btn-pay {
      width: auto;
    }

    &__more {
      &-expander {
        grid-column: 1 / 2 span;
        font-weight: 400;
        font-size: 10px;
        line-height: 13px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        letter-spacing: 0.01em;
        color: #33A1FB;
        border-bottom: 1px solid #FFFFFF;
        transition: padding .5s ease-in-out, border-bottom-color .5s ease-in-out;
        cursor: pointer;

        svg {
          fill: #33A1FB;
          transition: transform .3s ease-in-out;
          transform: rotate(180deg);
        }

        &.expanded {
          color: #788CA1;
          border-bottom: 1px solid #EBEFF2;
          padding-bottom: 8px;

          svg {
            transform: rotate(0);
          }
        }
      }

      &-content {
        padding-top: 0;
        grid-column: 1 / 2 span;
        //display: grid;
        //grid-template-columns: 1fr 1fr;
        max-height: 0;
        transition: max-height .5s ease-in-out, padding .5s ease-in-out;
        overflow: hidden;

        &.expanded {
          max-height: 500px;
          padding-top: 26px;
        }
      }
    }
  }

  @media (max-width: 576px) {
    box-sizing: border-box;
    margin-left: -15px !important;
    margin-right: -15px;
    border-radius: 0;
  }
}
</style>
